<template>
    <div >
   <div ref="mapOption3" class="line2" id="line2"></div>
  
   </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import Pagination from 'components/pagination';
  // 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
  // import * as echarts from 'echarts/core';
  // 引入柱状图图表，图表后缀都为 Chart
  // import { BarChart } from 'echarts/charts';
  
  export default {
    name: 'reportList',
    props:['start','end','symbol','type'],
    data () {
        return {
            datas:{}
        }
    },
    computed: {
    ...mapState('report',['transcationData'])
    },
    components: {
      Pagination
    },
    mounted () {
    
  
        // this.getTranscation({
        //     endTime: '1668355200000',
        //     startTime: '1667232000000',
        //     symbol: "",
        //     type: 0
        // }).then(res=>{

        //     this.datas=res.data
        // })
        // this.showChart4()
        
    },
    watch: {
        start:{
            handler(val,oldVal){
                if(val){
                this.getTranscation({
                    endTime: this.end ,
                    startTime: val,
                    symbol: this.symbol,
                    type: this.type
                }).then(res=>{
                    console.log('start-res',res);
                    // this.showChart3(res)
                    this.datas=res.data
                    this.showChart4()
                   
                })
            }
            }
        }
    },
    methods: {
        ...mapActions('report',['getTranscation']),
      showChart4() {
              // (1)初始化echarts
              const mychart = this.$echarts.init(this.$refs.mapOption3);
              const option = {
                        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                        title: {
                        // text: '交易人数 \n 总人数'
                        },
                        tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                            backgroundColor: '#37A2FF'
                            }
                        }
                        },
                        legend: {
                        data: ['次数'],
                        // left:'auto',
                        top:20
                        },
                        toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                        },
                        grid: {
                        left: '2%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                        },
                        xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: this.transcationData?this.transcationData.avgTradeNumberList.map(item=>{return ''}):[],
                            "axisLine":{"show":false},//隐藏x轴线
                            "axisTick":{"show":false},//隐藏x轴刻度
                        }
                        ],
                        yAxis: [
                        {
                            show: false,
                            type: 'value',
                            // name:''
                            "axisLine":{"show":false},//隐藏Y轴线
                            "aYisTick":{"show":false},//隐藏Y轴刻度
                        }
                        ],
                        series: [
                        {
                            name: '次数',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                            width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgb(139,176,205)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(139,176,205)'
                            }
                            ])
                            },
                            emphasis: {
                            focus: 'series'
                            },
                            data:this.transcationData.avgTradeNumberList
                        }
                        ]
                    };
              mychart.setOption(option);
              window.addEventListener("resize", () => {
             	mychart.resize();
            })
          },
        
     
    }
  };
  </script>
  
  <style lang="less" scoped>
    
      .line2{
        width: 100%;
        height: 200px;
        // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        border-top: 1px solid whitesmoke;
        // :hover{
        //     box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
        // }
      }
  </style>
  